export default __webpack_public_path__ + "static/media/Snd_TryV.61592a35.mp3";